import React, { useEffect, useId, useRef } from 'react';

const LOGO_WIDTH = 2172;
const LOGO_HEIGHT = 560;
const BASELINE = 351;
const X_POINTS = [0,6,12,18,24,30,36,42,48,54,60,66,72,78,84,90,96,102,108,114,120,126,132,138,144,150,156,162,168,174,180,186,192,198,204,210,216,222,228,234,240,246,252,258,264,270,276,282,288,294,300,306,312,318,324,330,336,342,348,354,360,366,372,378,384,390,396,402,408,414,420,426,432,438,444,450,456,462,468,474,480,486,492,498,504,510,516,522,528,534,540,546,552,558,564,570,576,582,588,594,600,606,612,618,624,630,636,642,648,654,660,666,672,678,684,690,696,702,708,714,720,726,732,738,744,750,756,762,768,774,780,786,792,798,804,810,816,822,828,834,840,846,852,858,864,870,876,882,888,894,900,906,912,918,924,930,936,942,948,954,960,966,972,978,984,990,996,1002,1008,1014,1020,1026,1032,1038,1044,1050,1056,1062,1068,1074,1080,1086,1092,1098,1104,1110,1116,1122,1128,1134,1140,1146,1152,1158,1164,1170,1176,1182,1188,1194,1200,1206,1212,1218,1224,1230,1236,1242,1248,1254,1260,1266,1272,1278,1284,1290,1296,1302,1308,1314,1320,1326,1332,1338,1344,1350,1356,1362,1368,1374,1380,1386,1392,1398,1404,1410,1416,1422,1428,1434,1440,1446,1452,1458,1464,1470,1476,1482,1488,1494,1500,1506,1512,1518,1524,1530,1536,1542,1548,1554,1560,1566,1572,1578,1584,1590,1596,1602,1608,1614,1620,1626,1632,1638,1644,1650,1656,1662,1668,1674,1680,1686,1692,1698,1704,1710,1716,1722,1728,1734,1740,1746,1752,1758,1764,1770,1776,1782,1788,1794,1800,1806,1812,1818,1824,1830,1836,1842,1848,1854,1860,1866,1872,1878,1884,1890,1896,1902,1908,1914,1920,1926,1932,1938,1944,1950,1956,1962,1968,1974,1980,1986,1992,1998,2004,2010,2016,2022,2028,2034,2040,2046,2052,2058,2064,2070,2076,2082,2088,2094,2100,2106,2112,2118,2124,2130,2136,2142,2148,2154,2160,2166,2171];
const TOP_AMPLITUDES = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1,1,3,4,9,11,15,24,30,22,15,18,23,31,47,53,37,22,34,53,47,38,48,47,54,79,86,65,55,72,72,43,61,64,62,61,56,71,75,85,89,113,120,100,100,94,99,99,117,129,124,142,165,201,201,170,142,130,132,119,141,140,112,104,99,108,137,137,103,98,108,112,112,102,97,103,98,91,101,93,85,97,109,101,89,94,98,93,104,117,114,105,110,116,149,157,142,127,145,189,203,191,156,141,132,131,137,162,162,137,118,111,128,128,109,109,97,104,118,137,118,103,113,99,91,86,100,93,96,117,132,129,105,105,125,125,102,117,130,117,121,118,126,171,172,145,127,132,149,139,157,157,185,185,175,186,215,240,230,204,198,207,225,225,263,308,328,310,262,225,212,227,223,196,236,237,209,182,197,199,166,147,147,136,151,142,132,138,143,170,173,148,137,118,98,93,117,117,96,89,79,81,101,110,100,84,87,97,112,137,133,108,105,100,125,126,115,136,157,143,168,199,199,164,137,119,101,109,127,127,109,96,96,89,87,105,105,83,80,82,73,92,92,82,89,98,127,142,131,125,125,129,175,177,147,122,143,138,113,95,100,94,100,93,91,92,79,83,88,104,93,92,104,129,121,122,130,155,193,200,176,161,159,135,132,109,101,97,96,99,89,113,112,87,96,124,112,81,72,94,102,85,61,53,49,43,62,62,68,82,72,55,41,36,43,54,45,34,37,24,20,20,13,10,15,22,15,12,11,5,6,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
const BOTTOM_AMPLITUDES = [0,0,14,14,14,15,16,17,17,19,19,20,24,24,25,28,29,31,31,36,38,42,52,61,52,47,47,50,60,74,79,64,50,62,78,72,64,74,72,81,98,101,83,81,97,97,75,88,94,94,92,89,98,101,107,113,133,140,123,125,117,127,127,142,153,146,152,175,200,200,180,162,160,150,135,155,153,131,124,121,130,156,156,121,123,127,136,136,127,121,125,120,119,126,116,109,119,133,125,113,113,118,110,118,129,127,118,129,134,161,167,151,142,156,193,200,197,165,147,147,144,151,177,177,152,132,129,143,143,132,131,120,124,133,144,132,126,134,127,115,110,117,114,117,132,150,145,131,130,137,136,112,123,131,125,139,136,145,175,175,149,146,147,163,169,186,193,200,200,196,177,174,191,182,167,179,188,200,200,200,200,200,200,200,200,193,200,195,174,195,198,174,156,163,166,149,133,134,131,144,138,128,133,141,166,167,146,141,127,108,111,130,130,113,111,106,104,115,125,113,109,109,116,128,148,144,124,130,126,146,146,131,142,159,159,177,200,200,180,153,135,126,135,152,152,132,118,120,113,116,132,132,116,111,113,103,118,118,107,116,122,150,164,153,147,147,148,194,195,166,143,162,156,135,117,125,117,124,116,116,117,108,110,110,125,116,113,121,130,132,144,151,158,199,200,182,148,152,144,142,128,120,114,118,122,111,129,129,111,117,140,129,102,93,111,116,102,84,79,72,71,83,83,94,107,97,80,68,66,66,78,69,59,61,48,47,47,39,36,42,47,40,35,35,30,31,29,25,24,22,20,19,19,18,17,16,16,15,15,14,14,0,0];

const modulationAt = (index: number, elapsed: number) => {
  if (elapsed <= 0) return 1;
  const center = (X_POINTS.length - 1) / 2;
  const distanceFromCenter = Math.abs(index - center) / center;
  const brandStability = .68 + distanceFromCenter * .32;
  const voiceEnergy = .82 + Math.sin(elapsed * .0012 + Math.sin(elapsed * .00037)) * .18;
  const broadCluster = Math.sin(elapsed * .00165 + index * .051) * .13;
  const driftingCluster = Math.sin(elapsed * .00108 - index * .029 + Math.sin(elapsed * .00043) * 1.2) * .085;
  const fineDetail = Math.sin(elapsed * .0024 + index * .18) * .04;

  return 1 + (broadCluster + driftingCluster + fineDetail) * brandStability * voiceEnergy;
};

const buildWavePath = (reveal: number, elapsed: number, depth: number) => {
  const top = X_POINTS.map((x, index) => {
    const amplitude = TOP_AMPLITUDES[index] * modulationAt(index, elapsed) * reveal * depth;
    return `${x},${(BASELINE - amplitude).toFixed(1)}`;
  }).join(' L ');
  const bottom = X_POINTS.map((x, index) => {
    const reverseIndex = X_POINTS.length - index - 1;
    const amplitude = BOTTOM_AMPLITUDES[reverseIndex] * modulationAt(reverseIndex + 19, elapsed) * reveal * depth;
    return `${X_POINTS[reverseIndex]},${(BASELINE + amplitude).toFixed(1)}`;
  }).join(' L ');
  return `M ${top} L ${bottom} Z`;
};

const buildNeedlePath = (reveal: number, elapsed: number) => X_POINTS
  .filter((_, index) => index % 2 === 0)
  .map((x, filteredIndex) => {
    const index = filteredIndex * 2;
    const pulse = modulationAt(index + 7, elapsed);
    const top = BASELINE - TOP_AMPLITUDES[index] * reveal * pulse * .9;
    const bottom = BASELINE + BOTTOM_AMPLITUDES[index] * reveal * pulse * .9;
    return `M ${x} ${top.toFixed(1)} L ${x} ${bottom.toFixed(1)}`;
  }).join(' ');

const staticOuterPath = buildWavePath(1, 0, 1);
const staticInnerPath = buildWavePath(1, 0, .68);
const staticCorePath = buildWavePath(1, 0, .24);
const staticNeedlePath = buildNeedlePath(1, 0);
const collapsedWavePath = buildWavePath(0, 0, 1);
const collapsedNeedlePath = buildNeedlePath(0, 0);

type AnimatedLogoProps = {
  className?: string;
};

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ className = '' }) => {
  const outerRef = useRef<SVGPathElement | null>(null);
  const innerRef = useRef<SVGPathElement | null>(null);
  const coreRef = useRef<SVGPathElement | null>(null);
  const needlesRef = useRef<SVGPathElement | null>(null);
  const instanceId = useId().replace(/:/g, '');

  useEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    const core = coreRef.current;
    const needles = needlesRef.current;
    if (!outer || !inner || !core || !needles) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      outer.setAttribute('d', staticOuterPath);
      inner.setAttribute('d', staticInnerPath);
      core.setAttribute('d', staticCorePath);
      needles.setAttribute('d', staticNeedlePath);
      return;
    }

    let animationFrame = 0;
    let previousFrame = 0;
    const startedAt = performance.now();

    const draw = (now: number) => {
      if (now - previousFrame < 31) {
        animationFrame = requestAnimationFrame(draw);
        return;
      }
      previousFrame = now;
      const introElapsed = now - startedAt;
      const introProgress = Math.min(1, Math.max(0, introElapsed / 1550));
      const reveal = 1 - Math.pow(1 - introProgress, 4);
      const livingElapsed = Math.max(0, introElapsed - 1300);

      outer.setAttribute('d', buildWavePath(reveal, livingElapsed, 1));
      inner.setAttribute('d', buildWavePath(reveal, livingElapsed, .68));
      core.setAttribute('d', buildWavePath(reveal, livingElapsed, .24));
      needles.setAttribute('d', buildNeedlePath(reveal, livingElapsed));
      animationFrame = requestAnimationFrame(draw);
    };

    animationFrame = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(animationFrame);
  }, []);

  const outerGradient = `animated-logo-outer-${instanceId}`;
  const innerGradient = `animated-logo-inner-${instanceId}`;
  const glow = `animated-logo-glow-${instanceId}`;

  return (
    <span className={`animated-logo ${className}`} role="img" aria-label="RESERVOLUTION">
      <svg viewBox={`0 0 ${LOGO_WIDTH} ${LOGO_HEIGHT}`} aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet">
        <defs>
          <linearGradient id={outerGradient} x1="0" y1="0" x2="0" y2={LOGO_HEIGHT} gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#173cff" />
            <stop offset=".5" stopColor="#006dff" />
            <stop offset=".58" stopColor="#18bfff" />
            <stop offset=".615" stopColor="#c9f6ff" />
            <stop offset=".627" stopColor="#ffffff" />
            <stop offset=".64" stopColor="#c9f6ff" />
            <stop offset=".68" stopColor="#18bfff" />
            <stop offset=".76" stopColor="#006dff" />
            <stop offset="1" stopColor="#173cff" />
          </linearGradient>
          <linearGradient id={innerGradient} x1="0" y1="0" x2="0" y2={LOGO_HEIGHT} gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#0077ff" stopOpacity=".2" />
            <stop offset=".55" stopColor="#4dd9ff" stopOpacity=".72" />
            <stop offset=".61" stopColor="#ffffff" stopOpacity=".98" />
            <stop offset=".65" stopColor="#ffffff" stopOpacity=".98" />
            <stop offset=".71" stopColor="#4dd9ff" stopOpacity=".72" />
            <stop offset="1" stopColor="#0077ff" stopOpacity=".2" />
          </linearGradient>
          <filter id={glow} x="-20%" y="-40%" width="140%" height="180%">
            <feGaussianBlur stdDeviation="9" result="blur" />
            <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
        </defs>
        <path ref={outerRef} d={collapsedWavePath} fill={`url(#${outerGradient})`} className="animated-logo-outer" />
        <path ref={innerRef} d={collapsedWavePath} fill={`url(#${innerGradient})`} className="animated-logo-inner" filter={`url(#${glow})`} />
        <path ref={needlesRef} d={collapsedNeedlePath} fill="none" stroke="#c7f6ff" strokeWidth="3.4" strokeLinecap="round" className="animated-logo-needles" />
        <path ref={coreRef} d={collapsedWavePath} fill="#f7fdff" className="animated-logo-core" filter={`url(#${glow})`} />
        <line x1="28" y1={BASELINE} x2={LOGO_WIDTH - 28} y2={BASELINE} className="animated-logo-zero-line" />
        <image href="/reservolution-wordmark.webp" x="0" y="0" width={LOGO_WIDTH} height="724" preserveAspectRatio="xMidYMid meet" className="animated-logo-wordmark" />
      </svg>
    </span>
  );
};

export default AnimatedLogo;
